export const DLPrefix = 'marinesamraj://';
